import type { PnlHierarchyMember } from 'src/components/star-grid/starGridTypes';
import { indexMemberTree } from 'src/components/star-grid/utils/subset-editor/memberSubset';

export const selectedMemberPositions = (members: readonly PnlHierarchyMember[], values: readonly string[], multiple: boolean): string[] => {
  const selected = new Set(values);
  const positions = [...indexMemberTree(members).values()].filter((entry) => selected.has(entry.id)).map((entry) => entry.key);
  return multiple ? positions : positions.slice(0, 1);
};
